var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodMoodEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2517_2133)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 19C15.9706 19 20 14.9706 20 10C20 5.02944 15.9706 1 11 1C6.02944 1 2 5.02944 2 10C2 14.9706 6.02944 19 11 19ZM5.41449 9.69139C6.03044 9.69139 6.52977 9.19206 6.52977 8.57611C6.52977 7.96017 6.03044 7.46084 5.41449 7.46084C4.79854 7.46084 4.29922 7.96017 4.29922 8.57611C4.29922 9.19206 4.79854 9.69139 5.41449 9.69139ZM16.8309 9.69139C17.4469 9.69139 17.9462 9.19206 17.9462 8.57611C17.9462 7.96017 17.4469 7.46084 16.8309 7.46084C16.215 7.46084 15.7156 7.96017 15.7156 8.57611C15.7156 9.19206 16.215 9.69139 16.8309 9.69139ZM8.26425 12.1182C8.26425 11.6972 7.92296 11.3559 7.50195 11.3559C7.08095 11.3559 6.73965 11.6972 6.73965 12.1182C6.73965 14.2243 8.82452 15.6442 10.9991 15.6442C13.1739 15.6442 15.2585 14.2226 15.2585 12.1182C15.2585 11.6972 14.9172 11.3559 14.4962 11.3559C14.0752 11.3559 13.7339 11.6972 13.7339 12.1182C13.7339 13.0656 12.6859 14.1196 10.9991 14.1196C9.31195 14.1196 8.26425 13.0668 8.26425 12.1182Z",
    fill: "#147AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2517_2133",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2517_2133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2517_2133",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodMoodEmoji);
export default __webpack_public_path__ + "static/media/GoodMoodEmoji.9525d41436f090d8386bcbb6f8fdde55.svg";
export { ForwardRef as ReactComponent };